import React from "react";

const LibrarySong = ({
  songs,
  setSongs,
  song,
  setCurrentSong,
  audioRef,
  isPlaying,
  id,
}) => {
  const songSelectHandler = async () => {
    await setCurrentSong(song);

    // Add active state
    const newSongs = songs.map((song) => {
      if (song.id === id) {
        return {
          ...song,
          active: true,
        };
      } else {
        return {
          ...song,
          active: false,
        };
      }
    });
    await setSongs(newSongs);

    // check if song is playing
    if (isPlaying) audioRef.current.play();
  };

  return (
    <div
      onClick={songSelectHandler}
      className={`library-song ${song.active ? "selected" : ""}`}
    >

      <div className="song-description">
        <h6>{song.name}</h6>
        <h4>{song.artist}</h4>
      </div>
    </div>
  );
};

export default LibrarySong;
